import SplitPane from './SplitPane';
import Media from './Media';
import Content from './Content';

SplitPane.Media = Media;
SplitPane.Content = Content;

export { SplitPane };
